(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bluu-about-blog-cards"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-about-hero"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-about-history"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-about-icon-benefits"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-about-image-story"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-about-impact-stats"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-about-retailer-quote"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-about-sticky-cards"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-about-team-intro"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-b2b-contact-form"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-b2b-contact-intro"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-b2b-faq"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-b2b-hero"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-b2b-partner-cards"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-b2b-scroll-text"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-b2b-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('solution-showcase-slideshow')) {
    customElements.define(
      'solution-showcase-slideshow',
      class SolutionShowcaseSlideshow extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;

          this.initialized = true;
          this.slides = Array.from(this.querySelectorAll('[data-solution-showcase-slide]'));
          this.previousButton = this.querySelector('.slider-pagination__arrow--previous');
          this.nextButton = this.querySelector('.slider-pagination__arrow--next');
          this.progressThumb = this.querySelector('.slider-pagination__progress-thumb');
          this.current = 0;
          this.touchStartX = null;
          this.handlePreviousClick = () => this.go(-1);
          this.handleNextClick = () => this.go(1);
          this.boundKeydown = this.handleKeydown.bind(this);
          this.boundTouchStart = this.handleTouchStart.bind(this);
          this.boundTouchEnd = this.handleTouchEnd.bind(this);
          this.boundThemeBlockSelect = this.handleThemeBlockSelect.bind(this);

          this.previousButton?.addEventListener('click', this.handlePreviousClick);
          this.nextButton?.addEventListener('click', this.handleNextClick);
          this.addEventListener('keydown', this.boundKeydown);
          this.addEventListener('touchstart', this.boundTouchStart, { passive: true });
          this.addEventListener('touchend', this.boundTouchEnd, { passive: true });
          document.addEventListener('shopify:block:select', this.boundThemeBlockSelect);

          this.select(0, false, 1);
        }

        disconnectedCallback() {
          this.previousButton?.removeEventListener('click', this.handlePreviousClick);
          this.nextButton?.removeEventListener('click', this.handleNextClick);
          this.removeEventListener('keydown', this.boundKeydown);
          this.removeEventListener('touchstart', this.boundTouchStart);
          this.removeEventListener('touchend', this.boundTouchEnd);
          document.removeEventListener('shopify:block:select', this.boundThemeBlockSelect);
          this.initialized = false;
        }

        go(direction) {
          const slideCount = this.slides.length;

          if (slideCount <= 1) return;

          const nextIndex = (this.current + direction + slideCount) % slideCount;
          this.select(nextIndex, true, direction);
        }

        select(index, animate, direction = 1) {
          if (!this.slides.length) return;

          const nextIndex = Math.max(0, Math.min(index, this.slides.length - 1));
          const previousIndex = this.current;
          const previousSlide = this.slides[previousIndex];
          const nextSlide = this.slides[nextIndex];
          const previousMotion = previousSlide?.querySelector('[data-solution-showcase-copy-motion]');
          const nextMotion = nextSlide?.querySelector('[data-solution-showcase-copy-motion]');
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const shouldAnimate = animate && previousIndex !== nextIndex && !reducedMotion;

          this.current = nextIndex;

          this.slides.forEach((slide, slideIndex) => {
            const isActive = slideIndex === nextIndex;

            slide.classList.toggle('is-active', isActive);
            slide.setAttribute('aria-hidden', String(!isActive));
            slide.toggleAttribute('inert', !isActive);
          });

          if (shouldAnimate) {
            const incomingOffset = direction < 0 ? -100 : 100;
            const outgoingOffset = incomingOffset * -1;
            const animationOptions = {
              duration: 520,
              easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
            };

            previousMotion?.getAnimations().forEach((animation) => animation.cancel());
            nextMotion?.getAnimations().forEach((animation) => animation.cancel());

            previousMotion?.animate(
              [
                { transform: 'translateX(0%)', opacity: 1 },
                { transform: `translateX(${outgoingOffset}%)`, opacity: 0 },
              ],
              animationOptions
            );
            nextMotion?.animate(
              [
                { transform: `translateX(${incomingOffset}%)`, opacity: 0 },
                { transform: 'translateX(0%)', opacity: 1 },
              ],
              animationOptions
            );
          }

          const accentColor = nextSlide?.dataset.accentColor;

          if (accentColor) {
            this.style.setProperty('--solution-showcase-active-color', accentColor);
          }

          if (this.progressThumb) {
            const slideCount = this.slides.length;
            const width = 100 / slideCount;
            const maxIndex = Math.max(slideCount - 1, 1);
            const travel = Math.max(100 - width, 0);

            this.progressThumb.style.width = `${width}%`;
            this.progressThumb.style.left = `${(nextIndex / maxIndex) * travel}%`;
            this.progressThumb.style.transform = 'none';
          }
        }

        handleKeydown(event) {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.go(-1);
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.go(1);
          }
        }

        handleTouchStart(event) {
          this.touchStartX = event.changedTouches[0]?.clientX ?? null;
        }

        handleTouchEnd(event) {
          if (this.touchStartX === null) return;

          const touchEndX = event.changedTouches[0]?.clientX ?? this.touchStartX;
          const distance = touchEndX - this.touchStartX;

          this.touchStartX = null;

          if (Math.abs(distance) < 44) return;

          this.go(distance > 0 ? -1 : 1);
        }

        handleThemeBlockSelect(event) {
          const selectedSlide = event.target?.closest?.('[data-solution-showcase-slide]');
          const index = this.slides.indexOf(selectedSlide);

          if (index >= 0) {
            const direction = index < this.current ? -1 : 1;
            this.select(index, true, direction);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-benefits-image"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-blog-cards"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-collection-cards"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-engagement-cta"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-engagement-curved-text"] && !Shopify.designMode) return;
  try {
    
  class ScrollingPathText extends HTMLElement {
    connectedCallback() {
      this.path = this.querySelector('[data-scrolling-path-curve]');
      this.stage = this.querySelector('[data-scrolling-path-stage]');
      this.copy = this.querySelector('[data-scrolling-path-copy]');
      this.textPath = this.querySelector('[data-scrolling-path-text-path]');
      this.accessibleText = this.querySelector('.visually-hidden');

      if (!this.path || !this.stage || !this.copy || !this.textPath || !this.accessibleText) return;

      this.abortController = new AbortController();
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.isVisible = true;
      this.frame = 0;
      this.patternLength = 1;
      this.pathLength = 1;
      this.scrollTravel = 0;
      this.stageTravel = 0;
      this.textTravel = 0;
      this.baseTextOffset = 0;

      this.onViewportChange = () => this.requestUpdate();
      this.onMotionPreferenceChange = () => this.requestUpdate();
      this.onTouchScroll = (event) => {
        const scrollY = event.detail?.scrollY;
        if (!this.isVisible || !Number.isFinite(scrollY)) return;

        window.cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.updatePosition(scrollY);
      };

      window.addEventListener('scroll', this.onViewportChange, {
        passive: true,
        signal: this.abortController.signal,
      });
      window.addEventListener('resize', this.onViewportChange, {
        passive: true,
        signal: this.abortController.signal,
      });
      this.reducedMotion.addEventListener('change', this.onMotionPreferenceChange, {
        signal: this.abortController.signal,
      });
      document.addEventListener('bluu:touch-scroll', this.onTouchScroll, {
        signal: this.abortController.signal,
      });

      this.resizeObserver = new ResizeObserver(() => this.measure());
      this.resizeObserver.observe(this);

      this.intersectionObserver = new IntersectionObserver((entries) => {
        this.isVisible = entries[0]?.isIntersecting ?? true;
        if (this.isVisible) this.requestUpdate();
      });
      this.intersectionObserver.observe(this);

      this.loadPath();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      window.cancelAnimationFrame(this.frame);
    }

    async loadPath() {
      const source = this.dataset.pathSource;

      if (source) {
        try {
          const response = await fetch(source);
          if (!response.ok) throw new Error('SVG request failed');

          const documentText = await response.text();
          const sourceDocument = new DOMParser().parseFromString(documentText, 'image/svg+xml');
          const sourceSvg = sourceDocument.querySelector('svg');
          const sourcePath = Array.from(sourceDocument.querySelectorAll('path')).find((path) => path.getAttribute('d'));

          if (!sourceSvg || !sourcePath || sourceDocument.querySelector('parsererror')) {
            throw new Error('No SVG path found');
          }

          const viewBox = this.parseViewBox(sourceSvg);
          this.path.setAttribute('d', sourcePath.getAttribute('d'));
          this.path.removeAttribute('transform');

          if (sourcePath.hasAttribute('transform')) {
            this.path.setAttribute('transform', sourcePath.getAttribute('transform'));
          }

          if (viewBox) this.stage.setAttribute('viewBox', viewBox.join(' '));
          this.dataset.pathStatus = 'loaded';
        } catch (error) {
          this.dataset.pathStatus = 'fallback';
        }
      }

      if (document.fonts?.ready) await document.fonts.ready;
      if (!this.isConnected) return;

      this.measure();
    }

    parseViewBox(svg) {
      const values = svg
        .getAttribute('viewBox')
        ?.trim()
        .split(/[\s,]+/)
        .map(Number);

      if (values?.length === 4 && values.every(Number.isFinite) && values[2] > 0 && values[3] > 0) {
        return values;
      }

      const width = Number.parseFloat(svg.getAttribute('width'));
      const height = Number.parseFloat(svg.getAttribute('height'));
      if (width > 0 && height > 0) return [0, 0, width, height];

      return null;
    }

    measure() {
      if (!this.isConnected || !this.clientWidth || !this.clientHeight) return;

      const amount = Number(this.dataset.scrollAmount) || 50;
      this.scrollTravel = this.clientWidth * (amount / 100);
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const configuredFontSize = Number(mobile ? this.dataset.fontSizeMobile : this.dataset.fontSize);
      const separator = this.dataset.separator ?? '•';
      const baseText = this.accessibleText.textContent.trim();
      const pattern = separator ? `${baseText}\u2002${separator}\u2002` : `${baseText}\u2003`;
      const initialMetrics = this.setStageTypography(this.scrollTravel, configuredFontSize, baseText);
      const initialTextTravel = Math.max(initialMetrics.textLength * initialMetrics.scale - this.clientWidth, 0);

      this.stageTravel = Math.max(this.scrollTravel, initialTextTravel * 1.5);
      let metrics = this.setStageTypography(this.stageTravel, configuredFontSize, baseText);
      let textScreenTravel = Math.max(metrics.textLength * metrics.scale - this.clientWidth, 0);
      const measuredStageTravel = Math.max(this.scrollTravel, textScreenTravel * 1.5);

      if (Math.abs(measuredStageTravel - this.stageTravel) > 0.5) {
        this.stageTravel = measuredStageTravel;
        metrics = this.setStageTypography(this.stageTravel, configuredFontSize, baseText);
        textScreenTravel = Math.max(metrics.textLength * metrics.scale - this.clientWidth, 0);
      }

      this.textTravel = Math.max(this.stageTravel - textScreenTravel, 0) / Math.max(metrics.scale, 0.001);
      this.pathLength = Math.max(this.path.getTotalLength(), 1);
      const viewBox = this.stage.viewBox.baseVal;
      const pathStart = this.path.getPointAtLength(0);
      this.baseTextOffset = this.path.hasAttribute('transform') ? 0 : Math.max(viewBox.x - pathStart.x, 0);

      this.textPath.textContent = pattern;
      const singlePatternLength = Math.max(this.copy.getComputedTextLength(), 1);
      const repetitions = Math.min(
        80,
        Math.max(
          12,
          Math.ceil((this.pathLength + this.baseTextOffset + this.textTravel) / singlePatternLength) + 4,
        ),
      );
      this.textPath.textContent = pattern.repeat(repetitions);
      this.patternLength = Math.max(this.copy.getComputedTextLength() / repetitions, 1);
      this.textPath.setAttribute('startOffset', this.baseTextOffset.toFixed(3));

      this.requestUpdate();
    }

    setStageTypography(stageTravel, configuredFontSize, text) {
      this.stage.style.width = `${this.clientWidth + stageTravel}px`;

      const viewBox = this.stage.viewBox.baseVal;
      const scale = Math.max(this.stage.clientWidth / viewBox.width, this.stage.clientHeight / viewBox.height);
      const fontSize = (Number.isFinite(configuredFontSize) ? configuredFontSize : 24) / Math.max(scale, 0.001);

      // A presentation attribute loses to the component's fallback CSS rule.
      // Set the inline style so the configured on-screen size wins after SVG scaling.
      this.copy.style.fontSize = `${fontSize.toFixed(3)}px`;
      this.textPath.textContent = text;

      return {
        scale,
        textLength: Math.max(this.copy.getComputedTextLength(), 1),
      };
    }

    requestUpdate() {
      if (!this.isVisible || this.frame) return;
      this.frame = window.requestAnimationFrame(() => {
        this.frame = 0;
        this.updatePosition();
      });
    }

    updatePosition(scrollY = null) {
      if (!this.stage) return;

      let progress = 0;

      if (!this.reducedMotion.matches) {
        const bounds = this.getBoundingClientRect();
        const scrollDelta = Number.isFinite(scrollY) ? scrollY - window.scrollY : 0;
        const top = bounds.top - scrollDelta;
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
        const visibleTravel = Math.max(viewportHeight + bounds.height, 1);
        const visibleProgress = Math.min(1, Math.max(0, (viewportHeight - top) / visibleTravel));
        const endpointHold = 0.05;
        progress = Math.min(1, Math.max(0, (visibleProgress - endpointHold) / (1 - endpointHold * 2)));
      }

      const motion = this.reducedMotion.matches
        ? 0
        : this.dataset.direction === 'reverse'
          ? -progress
          : progress - 1;
      const stageOffset = this.stageTravel * motion;
      const textOffset = this.baseTextOffset - this.textTravel * motion;

      this.style.setProperty('--scrolling-path-text-translate-x', `${stageOffset.toFixed(3)}px`);
      this.textPath.setAttribute('startOffset', textOffset.toFixed(3));
    }
  }

  if (!customElements.get('scroll-path-text')) {
    customElements.define('scroll-path-text', ScrollingPathText);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-engagement-eco-story-2"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-engagement-eco-story"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-engagement-hero"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-engagement-impact-stats"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-engagement-numbered-benefits"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-engagement-projects"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('project-showcase-slider')) {
    customElements.define(
      'project-showcase-slider',
      class ProjectShowcaseSlider extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;

          this.initialized = true;
          this.slides = Array.from(this.querySelectorAll('[data-project-showcase-slide]'));
          this.previousButton = this.querySelector('.slider-pagination__arrow--previous');
          this.nextButton = this.querySelector('.slider-pagination__arrow--next');
          this.progressThumb = this.querySelector('.slider-pagination__progress-thumb');
          this.current = Math.max(
            this.slides.findIndex((slide) => slide.classList.contains('is-active')),
            0
          );
          this.touchStartX = null;
          this.handlePreviousClick = () => this.go(-1);
          this.handleNextClick = () => this.go(1);
          this.boundKeydown = this.handleKeydown.bind(this);
          this.boundTouchStart = this.handleTouchStart.bind(this);
          this.boundTouchEnd = this.handleTouchEnd.bind(this);
          this.boundThemeBlockSelect = this.handleThemeBlockSelect.bind(this);

          this.previousButton?.addEventListener('click', this.handlePreviousClick);
          this.nextButton?.addEventListener('click', this.handleNextClick);
          this.addEventListener('keydown', this.boundKeydown);
          this.addEventListener('touchstart', this.boundTouchStart, { passive: true });
          this.addEventListener('touchend', this.boundTouchEnd, { passive: true });
          document.addEventListener('shopify:block:select', this.boundThemeBlockSelect);

          this.select(this.current, false, 1);
        }

        disconnectedCallback() {
          this.previousButton?.removeEventListener('click', this.handlePreviousClick);
          this.nextButton?.removeEventListener('click', this.handleNextClick);
          this.removeEventListener('keydown', this.boundKeydown);
          this.removeEventListener('touchstart', this.boundTouchStart);
          this.removeEventListener('touchend', this.boundTouchEnd);
          document.removeEventListener('shopify:block:select', this.boundThemeBlockSelect);
          this.initialized = false;
        }

        go(direction) {
          if (this.slides.length <= 1) return;

          const nextIndex = (this.current + direction + this.slides.length) % this.slides.length;
          this.select(nextIndex, true, direction);
        }

        select(index, animate, direction = 1) {
          if (!this.slides.length) return;

          const nextIndex = Math.max(0, Math.min(index, this.slides.length - 1));
          const previousIndex = this.current;
          const previousSlide = this.slides[previousIndex];
          const nextSlide = this.slides[nextIndex];
          const previousMotions = previousSlide
            ? Array.from(previousSlide.querySelectorAll('[data-project-showcase-copy-motion]'))
            : [];
          const nextMotions = nextSlide
            ? Array.from(nextSlide.querySelectorAll('[data-project-showcase-copy-motion]'))
            : [];
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const shouldAnimate = animate && previousIndex !== nextIndex && !reducedMotion;

          this.current = nextIndex;

          this.slides.forEach((slide, slideIndex) => {
            const isActive = slideIndex === nextIndex;

            slide.classList.toggle('is-active', isActive);
            slide.setAttribute('aria-hidden', String(!isActive));
            slide.toggleAttribute('inert', !isActive);
          });

          if (shouldAnimate) {
            const incomingOffset = direction < 0 ? -100 : 100;
            const outgoingOffset = incomingOffset * -1;
            const animationOptions = {
              duration: 520,
              easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
            };

            [...previousMotions, ...nextMotions].forEach((motion) => {
              motion.getAnimations().forEach((animation) => animation.cancel());
            });

            previousMotions.forEach((motion) => {
              motion.animate(
                [
                  { transform: 'translateX(0%)', opacity: 1 },
                  { transform: `translateX(${outgoingOffset}%)`, opacity: 0 },
                ],
                animationOptions
              );
            });

            nextMotions.forEach((motion) => {
              motion.animate(
                [
                  { transform: `translateX(${incomingOffset}%)`, opacity: 0 },
                  { transform: 'translateX(0%)', opacity: 1 },
                ],
                animationOptions
              );
            });
          }

          if (this.progressThumb) {
            const width = 100 / this.slides.length;
            const maxIndex = Math.max(this.slides.length - 1, 1);
            const travel = Math.max(100 - width, 0);

            this.progressThumb.style.width = `${width}%`;
            this.progressThumb.style.left = `${(nextIndex / maxIndex) * travel}%`;
            this.progressThumb.style.transform = 'none';
          }
        }

        handleKeydown(event) {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.go(-1);
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.go(1);
          }
        }

        handleTouchStart(event) {
          this.touchStartX = event.changedTouches[0]?.clientX ?? null;
        }

        handleTouchEnd(event) {
          if (this.touchStartX === null) return;

          const touchEndX = event.changedTouches[0]?.clientX ?? this.touchStartX;
          const distance = touchEndX - this.touchStartX;

          this.touchStartX = null;

          if (Math.abs(distance) < 44) return;

          this.go(distance > 0 ? -1 : 1);
        }

        handleThemeBlockSelect(event) {
          const selectedSlide = event.target?.closest?.('[data-project-showcase-slide]');
          const index = this.slides.indexOf(selectedSlide);

          if (index >= 0) {
            const direction = index < this.current ? -1 : 1;
            this.select(index, true, direction);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-engagement-water-story"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-faq-tabs"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-how-to-story"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-image-callout"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-jobs-card-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('expandable-card-slider')) {
    customElements.define(
      'expandable-card-slider',
      class ExpandableCardSlider extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;

          this.initialized = true;
          this.track = this.querySelector('[data-expandable-card-track]');
          this.previous = this.querySelector('.slider-pagination__arrow--previous');
          this.next = this.querySelector('.slider-pagination__arrow--next');
          this.progress = this.querySelector('.slider-pagination__progress-thumb');
          this.footer = this.querySelector('.expandable-card-slider__footer');
          this.animationFrame = 0;

          this.handleClick = this.onClick.bind(this);
          this.handleScroll = this.requestUpdate.bind(this);
          this.handleBlockSelect = this.onBlockSelect.bind(this);
          this.handlePrevious = () => this.scrollByCard(-1);
          this.handleNext = () => this.scrollByCard(1);

          this.addEventListener('click', this.handleClick);
          this.previous?.addEventListener('click', this.handlePrevious);
          this.next?.addEventListener('click', this.handleNext);
          this.track?.addEventListener('scroll', this.handleScroll, { passive: true });
          document.addEventListener('shopify:block:select', this.handleBlockSelect);

          if (this.track) {
            this.resizeObserver = new ResizeObserver(() => this.update());
            this.resizeObserver.observe(this.track);
          }

          this.update();
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.handleClick);
          this.previous?.removeEventListener('click', this.handlePrevious);
          this.next?.removeEventListener('click', this.handleNext);
          this.track?.removeEventListener('scroll', this.handleScroll);
          document.removeEventListener('shopify:block:select', this.handleBlockSelect);
          this.resizeObserver?.disconnect();
          window.cancelAnimationFrame(this.animationFrame);
          this.initialized = false;
        }

        onClick(event) {
          const button = event.target.closest('[data-expandable-card-toggle]');
          if (!button || !this.contains(button)) return;

          const card = button.closest('.expandable-card-slider__card');
          const details = card?.querySelector('[data-expandable-card-details]');
          if (!card || !details) return;

          const expanded = button.getAttribute('aria-expanded') !== 'true';
          card.classList.toggle('is-expanded', expanded);
          button.setAttribute('aria-expanded', String(expanded));
          button.setAttribute('aria-label', expanded ? button.dataset.labelExpanded : button.dataset.labelCollapsed);
          details.setAttribute('aria-hidden', String(!expanded));
          details.toggleAttribute('inert', !expanded);
        }

        onBlockSelect(event) {
          const card = event.target?.closest?.('.expandable-card-slider__card');
          if (!card || !this.contains(card)) return;

          card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }

        scrollByCard(direction) {
          if (!this.track) return;

          const firstCard = this.track.querySelector('.expandable-card-slider__card');
          const gap = parseFloat(getComputedStyle(this.track).columnGap || '0');
          const distance = firstCard ? firstCard.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;

          this.track.scrollBy({ left: distance * direction, behavior: 'smooth' });
        }

        requestUpdate() {
          if (this.animationFrame) return;

          this.animationFrame = window.requestAnimationFrame(() => {
            this.animationFrame = 0;
            this.update();
          });
        }

        update() {
          if (!this.track) return;

          const maxScroll = Math.max(this.track.scrollWidth - this.track.clientWidth, 0);
          const hasOverflow = maxScroll > 1;
          const scrollRatio = hasOverflow ? this.track.scrollLeft / maxScroll : 0;
          const thumbRatio =
            this.track.scrollWidth > 0 ? Math.min(this.track.clientWidth / this.track.scrollWidth, 1) : 1;
          const thumbWidth = Math.max(thumbRatio * 100, 14);
          const travel = Math.max(100 - thumbWidth, 0);

          if (this.previous) this.previous.disabled = !hasOverflow || this.track.scrollLeft <= 1;
          if (this.next) this.next.disabled = !hasOverflow || this.track.scrollLeft >= maxScroll - 1;
          if (this.footer) this.footer.hidden = !hasOverflow;

          if (this.progress) {
            this.progress.style.width = `${thumbWidth}%`;
            this.progress.style.left = `${scrollRatio * travel}%`;
            this.progress.style.transform = 'none';
          }
        }
      }
    );
  }

  if (!customElements.get('expandable-card-slider-updater')) {
    customElements.define(
      'expandable-card-slider-updater',
      class ExpandableCardSliderUpdater extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;

          this.initialized = true;
          this.handleProductSelect = this.onProductSelect.bind(this);
          document.addEventListener('shopify:product:select', this.handleProductSelect);
        }

        disconnectedCallback() {
          document.removeEventListener('shopify:product:select', this.handleProductSelect);
          this.initialized = false;
        }

        onProductSelect(event) {
          if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

          event.promise
            .then(({ detail }) => {
              if (!detail?.html || !this.isConnected) return;

              if (
                !detail.newProduct &&
                detail.productId &&
                this.dataset.productId &&
                detail.productId !== this.dataset.productId
              ) {
                return;
              }

              const newUpdater = Array.from(
                detail.html.querySelectorAll('expandable-card-slider-updater[data-expandable-card-slider-updater]')
              ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

              if (!newUpdater) return;

              const replacement = newUpdater.cloneNode(true);
              replacement.querySelectorAll('.fade-up-dark').forEach((element) => element.classList.add('is-visible'));
              this.replaceWith(replacement);
            })
            .catch((error) => {
              if (error?.name !== 'AbortError') {
                console.warn('[expandable-card-slider-updater] Event promise rejected:', error);
              }
            });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-jobs-hero"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-jobs-intro"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-jobs-open-positions"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-jobs-values"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-product-slider"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-product-spotlight"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bluu-retailer-logos"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-showcase-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-showcase-slider')) {
    customElements.define(
      'collection-showcase-slider',
      class CollectionShowcaseSlider extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;

          this.initialized = true;
          this.track = this.querySelector('[data-collection-showcase-track]');
          this.previous = this.querySelector('.slider-pagination__arrow--previous');
          this.next = this.querySelector('.slider-pagination__arrow--next');
          this.progress = this.querySelector('.slider-pagination__progress-thumb');
          this.onPreviousClick = () => this.scrollByCard(-1);
          this.onNextClick = () => this.scrollByCard(1);
          this.onScroll = () => this.update();
          this.onKeydown = (event) => this.handleKeydown(event);

          this.previous?.addEventListener('click', this.onPreviousClick);
          this.next?.addEventListener('click', this.onNextClick);
          this.track?.addEventListener('scroll', this.onScroll, { passive: true });
          this.track?.addEventListener('keydown', this.onKeydown);

          if (this.track) {
            this.resizeObserver = new ResizeObserver(() => this.update());
            this.resizeObserver.observe(this.track);
          }

          this.update();
        }

        disconnectedCallback() {
          this.previous?.removeEventListener('click', this.onPreviousClick);
          this.next?.removeEventListener('click', this.onNextClick);
          this.track?.removeEventListener('scroll', this.onScroll);
          this.track?.removeEventListener('keydown', this.onKeydown);
          this.resizeObserver?.disconnect();
          this.initialized = false;
        }

        scrollByCard(direction) {
          if (!this.track) return;

          const firstCard = this.track.querySelector('.collection-showcase-card');
          const gap = parseFloat(getComputedStyle(this.track).columnGap || '0');
          const distance = firstCard ? firstCard.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;

          this.track.scrollBy({
            left: distance * direction,
            behavior: 'smooth',
          });
        }

        handleKeydown(event) {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.scrollByCard(-1);
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.scrollByCard(1);
          }
        }

        update() {
          if (!this.track) return;

          const maxScroll = Math.max(this.track.scrollWidth - this.track.clientWidth, 0);
          const hasOverflow = maxScroll > 1;
          const scrollRatio = hasOverflow ? this.track.scrollLeft / maxScroll : 0;
          const thumbRatio =
            this.track.scrollWidth > 0 ? Math.min(this.track.clientWidth / this.track.scrollWidth, 1) : 1;
          const thumbWidth = Math.max(thumbRatio * 100, 14);
          const travel = Math.max(100 - thumbWidth, 0);

          if (this.previous) this.previous.disabled = !hasOverflow || this.track.scrollLeft <= 1;
          if (this.next) this.next.disabled = !hasOverflow || this.track.scrollLeft >= maxScroll - 1;

          if (this.progress) {
            this.progress.style.width = `${thumbWidth}%`;
            this.progress.style.left = `${scrollRatio * travel}%`;
            this.progress.style.transform = 'none';
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["expandable-card-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('expandable-card-slider')) {
    customElements.define(
      'expandable-card-slider',
      class ExpandableCardSlider extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;

          this.initialized = true;
          this.track = this.querySelector('[data-expandable-card-track]');
          this.previous = this.querySelector('.slider-pagination__arrow--previous');
          this.next = this.querySelector('.slider-pagination__arrow--next');
          this.progress = this.querySelector('.slider-pagination__progress-thumb');
          this.footer = this.querySelector('.expandable-card-slider__footer');
          this.animationFrame = 0;

          this.handleClick = this.onClick.bind(this);
          this.handleScroll = this.requestUpdate.bind(this);
          this.handleBlockSelect = this.onBlockSelect.bind(this);
          this.handlePrevious = () => this.scrollByCard(-1);
          this.handleNext = () => this.scrollByCard(1);

          this.addEventListener('click', this.handleClick);
          this.previous?.addEventListener('click', this.handlePrevious);
          this.next?.addEventListener('click', this.handleNext);
          this.track?.addEventListener('scroll', this.handleScroll, { passive: true });
          document.addEventListener('shopify:block:select', this.handleBlockSelect);

          if (this.track) {
            this.resizeObserver = new ResizeObserver(() => this.update());
            this.resizeObserver.observe(this.track);
          }

          this.update();
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.handleClick);
          this.previous?.removeEventListener('click', this.handlePrevious);
          this.next?.removeEventListener('click', this.handleNext);
          this.track?.removeEventListener('scroll', this.handleScroll);
          document.removeEventListener('shopify:block:select', this.handleBlockSelect);
          this.resizeObserver?.disconnect();
          window.cancelAnimationFrame(this.animationFrame);
          this.initialized = false;
        }

        onClick(event) {
          const button = event.target.closest('[data-expandable-card-toggle]');
          if (!button || !this.contains(button)) return;

          const card = button.closest('.expandable-card-slider__card');
          const details = card?.querySelector('[data-expandable-card-details]');
          if (!card || !details) return;

          const expanded = button.getAttribute('aria-expanded') !== 'true';
          card.classList.toggle('is-expanded', expanded);
          button.setAttribute('aria-expanded', String(expanded));
          button.setAttribute('aria-label', expanded ? button.dataset.labelExpanded : button.dataset.labelCollapsed);
          details.setAttribute('aria-hidden', String(!expanded));
          details.toggleAttribute('inert', !expanded);
        }

        onBlockSelect(event) {
          const card = event.target?.closest?.('.expandable-card-slider__card');
          if (!card || !this.contains(card)) return;

          card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }

        scrollByCard(direction) {
          if (!this.track) return;

          const firstCard = this.track.querySelector('.expandable-card-slider__card');
          const gap = parseFloat(getComputedStyle(this.track).columnGap || '0');
          const distance = firstCard ? firstCard.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;

          this.track.scrollBy({ left: distance * direction, behavior: 'smooth' });
        }

        requestUpdate() {
          if (this.animationFrame) return;

          this.animationFrame = window.requestAnimationFrame(() => {
            this.animationFrame = 0;
            this.update();
          });
        }

        update() {
          if (!this.track) return;

          const maxScroll = Math.max(this.track.scrollWidth - this.track.clientWidth, 0);
          const hasOverflow = maxScroll > 1;
          const scrollRatio = hasOverflow ? this.track.scrollLeft / maxScroll : 0;
          const thumbRatio =
            this.track.scrollWidth > 0 ? Math.min(this.track.clientWidth / this.track.scrollWidth, 1) : 1;
          const thumbWidth = Math.max(thumbRatio * 100, 14);
          const travel = Math.max(100 - thumbWidth, 0);

          if (this.previous) this.previous.disabled = !hasOverflow || this.track.scrollLeft <= 1;
          if (this.next) this.next.disabled = !hasOverflow || this.track.scrollLeft >= maxScroll - 1;
          if (this.footer) this.footer.hidden = !hasOverflow;

          if (this.progress) {
            this.progress.style.width = `${thumbWidth}%`;
            this.progress.style.left = `${scrollRatio * travel}%`;
            this.progress.style.transform = 'none';
          }
        }
      }
    );
  }

  if (!customElements.get('expandable-card-slider-updater')) {
    customElements.define(
      'expandable-card-slider-updater',
      class ExpandableCardSliderUpdater extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;

          this.initialized = true;
          this.handleProductSelect = this.onProductSelect.bind(this);
          document.addEventListener('shopify:product:select', this.handleProductSelect);
        }

        disconnectedCallback() {
          document.removeEventListener('shopify:product:select', this.handleProductSelect);
          this.initialized = false;
        }

        onProductSelect(event) {
          if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

          event.promise
            .then(({ detail }) => {
              if (!detail?.html || !this.isConnected) return;

              if (
                !detail.newProduct &&
                detail.productId &&
                this.dataset.productId &&
                detail.productId !== this.dataset.productId
              ) {
                return;
              }

              const newUpdater = Array.from(
                detail.html.querySelectorAll('expandable-card-slider-updater[data-expandable-card-slider-updater]')
              ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

              if (!newUpdater) return;

              const replacement = newUpdater.cloneNode(true);
              replacement.querySelectorAll('.fade-up-dark').forEach((element) => element.classList.add('is-visible'));
              this.replaceWith(replacement);
            })
            .catch((error) => {
              if (error?.name !== 'AbortError') {
                console.warn('[expandable-card-slider-updater] Event promise rejected:', error);
              }
            });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["helpcenter-blog-menu"] && !Shopify.designMode) return;
  try {
    
  function initHelpcenterArticleSwitchers(container) {
    const roots = container.querySelectorAll('[data-helpcenter-article-switcher]');

    roots.forEach((root) => {
      if (root.dataset.helpcenterArticleSwitcherInit === 'true') {
        return;
      }

      root.dataset.helpcenterArticleSwitcherInit = 'true';

      const links = Array.from(root.querySelectorAll('[data-helpcenter-article-link]'));
      const panels = Array.from(root.querySelectorAll('[data-helpcenter-article-panel]'));
      const panelsById = new Map(panels.map((panel) => [panel.dataset.helpcenterArticleId, panel]));

      function normalizePath(path) {
        return path.replace(/\/$/, '');
      }

      function articleIdFromLocation() {
        const currentPath = normalizePath(window.location.pathname);

        for (const panel of panels) {
          const panelUrl = new URL(panel.dataset.helpcenterArticleUrl, window.location.origin);

          if (normalizePath(panelUrl.pathname) === currentPath) {
            return panel.dataset.helpcenterArticleId;
          }
        }

        return null;
      }

      function setActiveArticle(articleId, pushHistory) {
        const activePanel = panelsById.get(articleId);

        if (!activePanel) {
          return;
        }

        panels.forEach((panel) => {
          const isActive = panel === activePanel;
          panel.hidden = !isActive;
          panel.classList.toggle('is-active', isActive);
        });

        links.forEach((link) => {
          const isActive = link.dataset.helpcenterArticleId === articleId;
          link.classList.toggle('is-active', isActive);
          if (isActive) {
            link.setAttribute('aria-current', 'page');
            link.scrollIntoView({ block: 'nearest', inline: 'center' });
          } else {
            link.removeAttribute('aria-current');
          }
        });

        if (pushHistory) {
          window.history.pushState(
            { helpcenterArticleId: articleId },
            activePanel.dataset.helpcenterArticleTitle || document.title,
            activePanel.dataset.helpcenterArticleUrl
          );
        }
      }

      root.addEventListener('click', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        const link = target ? target.closest('[data-helpcenter-article-link]') : null;

        if (!link || !root.contains(link)) {
          return;
        }

        const articleId = link.dataset.helpcenterArticleId;

        if (!panelsById.has(articleId)) {
          return;
        }

        event.preventDefault();

        const update = () => setActiveArticle(articleId, true);

        if (document.startViewTransition) {
          document.startViewTransition(update);
        } else {
          update();
        }
      });

      window.addEventListener('popstate', () => {
        const articleId = articleIdFromLocation();

        if (articleId) {
          setActiveArticle(articleId, false);
        }
      });
    });
  }

  initHelpcenterArticleSwitchers(document);

  document.addEventListener('shopify:section:load', (event) => {
    initHelpcenterArticleSwitchers(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-breadcrumb"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('page-breadcrumb-component')) {
    customElements.define(
      'page-breadcrumb-component',
      class PageBreadcrumbComponent extends HTMLElement {
        connectedCallback() {
          if (this.initialized || !this.hasAttribute('data-faq-category-breadcrumb')) return;

          this.initialized = true;
          this.currentItem = this.querySelector('[data-faq-category-current]');
          this.parentItems = Array.from(this.querySelectorAll('[data-faq-parent-item]'));
          this.fallbackLabel = this.dataset.fallbackLabel || '';
          this.handleRouteChange = () => this.updateCategory();

          window.addEventListener('hashchange', this.handleRouteChange);
          window.addEventListener('popstate', this.handleRouteChange);
          document.addEventListener('DOMContentLoaded', this.handleRouteChange, { once: true });
          this.updateCategory();
        }

        disconnectedCallback() {
          window.removeEventListener('hashchange', this.handleRouteChange);
          window.removeEventListener('popstate', this.handleRouteChange);
          document.removeEventListener('DOMContentLoaded', this.handleRouteChange);
          this.initialized = false;
        }

        getCategoryHandle() {
          const match = window.location.hash.match(/^#faq-([^?&]+)/i);
          if (!match) return '';

          try {
            return decodeURIComponent(match[1]).trim().toLowerCase();
          } catch (_error) {
            return match[1].trim().toLowerCase();
          }
        }

        getCategoryLabel(categoryHandle) {
          if (!categoryHandle) return '';

          const category = Array.from(document.querySelectorAll('[data-helpcenter-category]')).find(
            (candidate) => candidate.dataset.helpcenterCategory === categoryHandle
          );
          const categoryTitle = category?.querySelector('.faq-helpcenter__title')?.textContent?.trim();

          if (categoryTitle) return categoryTitle;

          return categoryHandle
            .split('-')
            .filter(Boolean)
            .map((word) => word.charAt(0).toLocaleUpperCase() + word.slice(1))
            .join(' ');
        }

        updateCategory() {
          if (!this.currentItem) return;

          const categoryHandle = this.getCategoryHandle();
          const showCategory = Boolean(categoryHandle && document.querySelector('faq-helpcenter'));
          const categoryLabel = showCategory ? this.getCategoryLabel(categoryHandle) : '';

          this.parentItems.forEach((item) => {
            item.hidden = !showCategory;
          });

          this.currentItem.textContent = categoryLabel || this.fallbackLabel;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-showcase-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('project-showcase-slider')) {
    customElements.define(
      'project-showcase-slider',
      class ProjectShowcaseSlider extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;

          this.initialized = true;
          this.slides = Array.from(this.querySelectorAll('[data-project-showcase-slide]'));
          this.previousButton = this.querySelector('.slider-pagination__arrow--previous');
          this.nextButton = this.querySelector('.slider-pagination__arrow--next');
          this.progressThumb = this.querySelector('.slider-pagination__progress-thumb');
          this.current = Math.max(
            this.slides.findIndex((slide) => slide.classList.contains('is-active')),
            0
          );
          this.touchStartX = null;
          this.handlePreviousClick = () => this.go(-1);
          this.handleNextClick = () => this.go(1);
          this.boundKeydown = this.handleKeydown.bind(this);
          this.boundTouchStart = this.handleTouchStart.bind(this);
          this.boundTouchEnd = this.handleTouchEnd.bind(this);
          this.boundThemeBlockSelect = this.handleThemeBlockSelect.bind(this);

          this.previousButton?.addEventListener('click', this.handlePreviousClick);
          this.nextButton?.addEventListener('click', this.handleNextClick);
          this.addEventListener('keydown', this.boundKeydown);
          this.addEventListener('touchstart', this.boundTouchStart, { passive: true });
          this.addEventListener('touchend', this.boundTouchEnd, { passive: true });
          document.addEventListener('shopify:block:select', this.boundThemeBlockSelect);

          this.select(this.current, false, 1);
        }

        disconnectedCallback() {
          this.previousButton?.removeEventListener('click', this.handlePreviousClick);
          this.nextButton?.removeEventListener('click', this.handleNextClick);
          this.removeEventListener('keydown', this.boundKeydown);
          this.removeEventListener('touchstart', this.boundTouchStart);
          this.removeEventListener('touchend', this.boundTouchEnd);
          document.removeEventListener('shopify:block:select', this.boundThemeBlockSelect);
          this.initialized = false;
        }

        go(direction) {
          if (this.slides.length <= 1) return;

          const nextIndex = (this.current + direction + this.slides.length) % this.slides.length;
          this.select(nextIndex, true, direction);
        }

        select(index, animate, direction = 1) {
          if (!this.slides.length) return;

          const nextIndex = Math.max(0, Math.min(index, this.slides.length - 1));
          const previousIndex = this.current;
          const previousSlide = this.slides[previousIndex];
          const nextSlide = this.slides[nextIndex];
          const previousMotions = previousSlide
            ? Array.from(previousSlide.querySelectorAll('[data-project-showcase-copy-motion]'))
            : [];
          const nextMotions = nextSlide
            ? Array.from(nextSlide.querySelectorAll('[data-project-showcase-copy-motion]'))
            : [];
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const shouldAnimate = animate && previousIndex !== nextIndex && !reducedMotion;

          this.current = nextIndex;

          this.slides.forEach((slide, slideIndex) => {
            const isActive = slideIndex === nextIndex;

            slide.classList.toggle('is-active', isActive);
            slide.setAttribute('aria-hidden', String(!isActive));
            slide.toggleAttribute('inert', !isActive);
          });

          if (shouldAnimate) {
            const incomingOffset = direction < 0 ? -100 : 100;
            const outgoingOffset = incomingOffset * -1;
            const animationOptions = {
              duration: 520,
              easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
            };

            [...previousMotions, ...nextMotions].forEach((motion) => {
              motion.getAnimations().forEach((animation) => animation.cancel());
            });

            previousMotions.forEach((motion) => {
              motion.animate(
                [
                  { transform: 'translateX(0%)', opacity: 1 },
                  { transform: `translateX(${outgoingOffset}%)`, opacity: 0 },
                ],
                animationOptions
              );
            });

            nextMotions.forEach((motion) => {
              motion.animate(
                [
                  { transform: `translateX(${incomingOffset}%)`, opacity: 0 },
                  { transform: 'translateX(0%)', opacity: 1 },
                ],
                animationOptions
              );
            });
          }

          if (this.progressThumb) {
            const width = 100 / this.slides.length;
            const maxIndex = Math.max(this.slides.length - 1, 1);
            const travel = Math.max(100 - width, 0);

            this.progressThumb.style.width = `${width}%`;
            this.progressThumb.style.left = `${(nextIndex / maxIndex) * travel}%`;
            this.progressThumb.style.transform = 'none';
          }
        }

        handleKeydown(event) {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.go(-1);
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.go(1);
          }
        }

        handleTouchStart(event) {
          this.touchStartX = event.changedTouches[0]?.clientX ?? null;
        }

        handleTouchEnd(event) {
          if (this.touchStartX === null) return;

          const touchEndX = event.changedTouches[0]?.clientX ?? this.touchStartX;
          const distance = touchEndX - this.touchStartX;

          this.touchStartX = null;

          if (Math.abs(distance) < 44) return;

          this.go(distance > 0 ? -1 : 1);
        }

        handleThemeBlockSelect(event) {
          const selectedSlide = event.target?.closest?.('[data-project-showcase-slide]');
          const index = this.slides.indexOf(selectedSlide);

          if (index >= 0) {
            const direction = index < this.current ? -1 : 1;
            this.select(index, true, direction);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-path-text"] && !Shopify.designMode) return;
  try {
    
  class ScrollingPathText extends HTMLElement {
    connectedCallback() {
      this.path = this.querySelector('[data-scrolling-path-curve]');
      this.stage = this.querySelector('[data-scrolling-path-stage]');
      this.copy = this.querySelector('[data-scrolling-path-copy]');
      this.textPath = this.querySelector('[data-scrolling-path-text-path]');
      this.accessibleText = this.querySelector('.visually-hidden');

      if (!this.path || !this.stage || !this.copy || !this.textPath || !this.accessibleText) return;

      this.abortController = new AbortController();
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.isVisible = true;
      this.frame = 0;
      this.patternLength = 1;
      this.pathLength = 1;
      this.scrollTravel = 0;
      this.stageTravel = 0;
      this.textTravel = 0;
      this.baseTextOffset = 0;

      this.onViewportChange = () => this.requestUpdate();
      this.onMotionPreferenceChange = () => this.requestUpdate();
      this.onTouchScroll = (event) => {
        const scrollY = event.detail?.scrollY;
        if (!this.isVisible || !Number.isFinite(scrollY)) return;

        window.cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.updatePosition(scrollY);
      };

      window.addEventListener('scroll', this.onViewportChange, {
        passive: true,
        signal: this.abortController.signal,
      });
      window.addEventListener('resize', this.onViewportChange, {
        passive: true,
        signal: this.abortController.signal,
      });
      this.reducedMotion.addEventListener('change', this.onMotionPreferenceChange, {
        signal: this.abortController.signal,
      });
      document.addEventListener('bluu:touch-scroll', this.onTouchScroll, {
        signal: this.abortController.signal,
      });

      this.resizeObserver = new ResizeObserver(() => this.measure());
      this.resizeObserver.observe(this);

      this.intersectionObserver = new IntersectionObserver((entries) => {
        this.isVisible = entries[0]?.isIntersecting ?? true;
        if (this.isVisible) this.requestUpdate();
      });
      this.intersectionObserver.observe(this);

      this.loadPath();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      window.cancelAnimationFrame(this.frame);
    }

    async loadPath() {
      const source = this.dataset.pathSource;

      if (source) {
        try {
          const response = await fetch(source);
          if (!response.ok) throw new Error('SVG request failed');

          const documentText = await response.text();
          const sourceDocument = new DOMParser().parseFromString(documentText, 'image/svg+xml');
          const sourceSvg = sourceDocument.querySelector('svg');
          const sourcePath = Array.from(sourceDocument.querySelectorAll('path')).find((path) => path.getAttribute('d'));

          if (!sourceSvg || !sourcePath || sourceDocument.querySelector('parsererror')) {
            throw new Error('No SVG path found');
          }

          const viewBox = this.parseViewBox(sourceSvg);
          this.path.setAttribute('d', sourcePath.getAttribute('d'));
          this.path.removeAttribute('transform');

          if (sourcePath.hasAttribute('transform')) {
            this.path.setAttribute('transform', sourcePath.getAttribute('transform'));
          }

          if (viewBox) this.stage.setAttribute('viewBox', viewBox.join(' '));
          this.dataset.pathStatus = 'loaded';
        } catch (error) {
          this.dataset.pathStatus = 'fallback';
        }
      }

      if (document.fonts?.ready) await document.fonts.ready;
      if (!this.isConnected) return;

      this.measure();
    }

    parseViewBox(svg) {
      const values = svg
        .getAttribute('viewBox')
        ?.trim()
        .split(/[\s,]+/)
        .map(Number);

      if (values?.length === 4 && values.every(Number.isFinite) && values[2] > 0 && values[3] > 0) {
        return values;
      }

      const width = Number.parseFloat(svg.getAttribute('width'));
      const height = Number.parseFloat(svg.getAttribute('height'));
      if (width > 0 && height > 0) return [0, 0, width, height];

      return null;
    }

    measure() {
      if (!this.isConnected || !this.clientWidth || !this.clientHeight) return;

      const amount = Number(this.dataset.scrollAmount) || 50;
      this.scrollTravel = this.clientWidth * (amount / 100);
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const configuredFontSize = Number(mobile ? this.dataset.fontSizeMobile : this.dataset.fontSize);
      const separator = this.dataset.separator ?? '•';
      const baseText = this.accessibleText.textContent.trim();
      const pattern = separator ? `${baseText}\u2002${separator}\u2002` : `${baseText}\u2003`;
      const initialMetrics = this.setStageTypography(this.scrollTravel, configuredFontSize, baseText);
      const initialTextTravel = Math.max(initialMetrics.textLength * initialMetrics.scale - this.clientWidth, 0);

      this.stageTravel = Math.max(this.scrollTravel, initialTextTravel * 1.5);
      let metrics = this.setStageTypography(this.stageTravel, configuredFontSize, baseText);
      let textScreenTravel = Math.max(metrics.textLength * metrics.scale - this.clientWidth, 0);
      const measuredStageTravel = Math.max(this.scrollTravel, textScreenTravel * 1.5);

      if (Math.abs(measuredStageTravel - this.stageTravel) > 0.5) {
        this.stageTravel = measuredStageTravel;
        metrics = this.setStageTypography(this.stageTravel, configuredFontSize, baseText);
        textScreenTravel = Math.max(metrics.textLength * metrics.scale - this.clientWidth, 0);
      }

      this.textTravel = Math.max(this.stageTravel - textScreenTravel, 0) / Math.max(metrics.scale, 0.001);
      this.pathLength = Math.max(this.path.getTotalLength(), 1);
      const viewBox = this.stage.viewBox.baseVal;
      const pathStart = this.path.getPointAtLength(0);
      this.baseTextOffset = this.path.hasAttribute('transform') ? 0 : Math.max(viewBox.x - pathStart.x, 0);

      this.textPath.textContent = pattern;
      const singlePatternLength = Math.max(this.copy.getComputedTextLength(), 1);
      const repetitions = Math.min(
        80,
        Math.max(
          12,
          Math.ceil((this.pathLength + this.baseTextOffset + this.textTravel) / singlePatternLength) + 4,
        ),
      );
      this.textPath.textContent = pattern.repeat(repetitions);
      this.patternLength = Math.max(this.copy.getComputedTextLength() / repetitions, 1);
      this.textPath.setAttribute('startOffset', this.baseTextOffset.toFixed(3));

      this.requestUpdate();
    }

    setStageTypography(stageTravel, configuredFontSize, text) {
      this.stage.style.width = `${this.clientWidth + stageTravel}px`;

      const viewBox = this.stage.viewBox.baseVal;
      const scale = Math.max(this.stage.clientWidth / viewBox.width, this.stage.clientHeight / viewBox.height);
      const fontSize = (Number.isFinite(configuredFontSize) ? configuredFontSize : 24) / Math.max(scale, 0.001);

      // A presentation attribute loses to the component's fallback CSS rule.
      // Set the inline style so the configured on-screen size wins after SVG scaling.
      this.copy.style.fontSize = `${fontSize.toFixed(3)}px`;
      this.textPath.textContent = text;

      return {
        scale,
        textLength: Math.max(this.copy.getComputedTextLength(), 1),
      };
    }

    requestUpdate() {
      if (!this.isVisible || this.frame) return;
      this.frame = window.requestAnimationFrame(() => {
        this.frame = 0;
        this.updatePosition();
      });
    }

    updatePosition(scrollY = null) {
      if (!this.stage) return;

      let progress = 0;

      if (!this.reducedMotion.matches) {
        const bounds = this.getBoundingClientRect();
        const scrollDelta = Number.isFinite(scrollY) ? scrollY - window.scrollY : 0;
        const top = bounds.top - scrollDelta;
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
        const visibleTravel = Math.max(viewportHeight + bounds.height, 1);
        const visibleProgress = Math.min(1, Math.max(0, (viewportHeight - top) / visibleTravel));
        const endpointHold = 0.05;
        progress = Math.min(1, Math.max(0, (visibleProgress - endpointHold) / (1 - endpointHold * 2)));
      }

      const motion = this.reducedMotion.matches
        ? 0
        : this.dataset.direction === 'reverse'
          ? -progress
          : progress - 1;
      const stageOffset = this.stageTravel * motion;
      const textOffset = this.baseTextOffset - this.textTravel * motion;

      this.style.setProperty('--scrolling-path-text-translate-x', `${stageOffset.toFixed(3)}px`);
      this.textPath.setAttribute('startOffset', textOffset.toFixed(3));
    }
  }

  if (!customElements.get('scroll-path-text')) {
    customElements.define('scroll-path-text', ScrollingPathText);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  if (!customElements.get('search-page-resources')) {
    customElements.define(
      'search-page-resources',
      class SearchPageResources extends HTMLElement {
        connectedCallback() {
          if (this.dataset.loaded === 'true') return;
          this.dataset.loaded = 'true';
          this.loadResources();
        }

        async loadResources() {
          const query = this.dataset.query?.trim();
          const container = this.querySelector('[data-search-supporting-results]');
          if (!query || !container) return;

          const root = window.Shopify?.routes?.root || '/';
          const route = window.Theme?.routes?.predictive_search_url || `${root}search/suggest`;
          const url = new URL(route, window.location.origin);
          url.searchParams.set('q', query);
          url.searchParams.set('resources[type]', 'collection,page,article');
          url.searchParams.set('resources[limit_scope]', 'each');
          url.searchParams.set('resources[limit]', '8');
          url.searchParams.set('resources[options][fields]', 'title,body,product_type,variants.title,vendor');
          url.searchParams.set('section_id', this.dataset.sectionId || 'predictive-search');

          try {
            const response = await fetch(url, { headers: { Accept: 'text/html' } });
            if (!response.ok) return;

            const markup = await response.text();
            const documentFragment = new DOMParser().parseFromString(markup, 'text/html');
            const resourceSections = documentFragment.querySelectorAll('.predictive-search-resource-links');
            if (!resourceSections.length) return;

            const resources = document.createDocumentFragment();
            resourceSections.forEach((resourceSection, index) => {
              const clonedSection = resourceSection.cloneNode(true);
              const heading = clonedSection.querySelector('[id]');
              if (heading) {
                const headingId = `${this.id}-resource-${index}`;
                heading.id = headingId;
                clonedSection.setAttribute('aria-labelledby', headingId);
              }
              resources.append(clonedSection);
            });

            container.replaceChildren(resources);
            this.hidden = false;
          } catch (error) {
            this.hidden = true;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section"] && !Shopify.designMode) return;
  try {
    
  class ConditionalContentSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.sectionWrapper = this.closest('.shopify-section');
      this.sectionWrapper?.toggleAttribute('hidden', this.dataset.complete !== 'true');
      document.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.initialized = false;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newContentSection = Array.from(
            detail.html.querySelectorAll('conditional-content-section[data-conditional-content-section]')
          ).find((element) => element.dataset.sectionId === this.dataset.sectionId);

          const newSectionWrapper = newContentSection?.closest('.shopify-section');
          if (!this.sectionWrapper || !newSectionWrapper) return;

          this.sectionWrapper.replaceWith(newSectionWrapper.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[conditional-content-section] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('conditional-content-section')) {
    customElements.define('conditional-content-section', ConditionalContentSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solution-showcase-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('solution-showcase-slideshow')) {
    customElements.define(
      'solution-showcase-slideshow',
      class SolutionShowcaseSlideshow extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;

          this.initialized = true;
          this.slides = Array.from(this.querySelectorAll('[data-solution-showcase-slide]'));
          this.previousButton = this.querySelector('.slider-pagination__arrow--previous');
          this.nextButton = this.querySelector('.slider-pagination__arrow--next');
          this.progressThumb = this.querySelector('.slider-pagination__progress-thumb');
          this.current = 0;
          this.touchStartX = null;
          this.handlePreviousClick = () => this.go(-1);
          this.handleNextClick = () => this.go(1);
          this.boundKeydown = this.handleKeydown.bind(this);
          this.boundTouchStart = this.handleTouchStart.bind(this);
          this.boundTouchEnd = this.handleTouchEnd.bind(this);
          this.boundThemeBlockSelect = this.handleThemeBlockSelect.bind(this);

          this.previousButton?.addEventListener('click', this.handlePreviousClick);
          this.nextButton?.addEventListener('click', this.handleNextClick);
          this.addEventListener('keydown', this.boundKeydown);
          this.addEventListener('touchstart', this.boundTouchStart, { passive: true });
          this.addEventListener('touchend', this.boundTouchEnd, { passive: true });
          document.addEventListener('shopify:block:select', this.boundThemeBlockSelect);

          this.select(0, false, 1);
        }

        disconnectedCallback() {
          this.previousButton?.removeEventListener('click', this.handlePreviousClick);
          this.nextButton?.removeEventListener('click', this.handleNextClick);
          this.removeEventListener('keydown', this.boundKeydown);
          this.removeEventListener('touchstart', this.boundTouchStart);
          this.removeEventListener('touchend', this.boundTouchEnd);
          document.removeEventListener('shopify:block:select', this.boundThemeBlockSelect);
          this.initialized = false;
        }

        go(direction) {
          const slideCount = this.slides.length;

          if (slideCount <= 1) return;

          const nextIndex = (this.current + direction + slideCount) % slideCount;
          this.select(nextIndex, true, direction);
        }

        select(index, animate, direction = 1) {
          if (!this.slides.length) return;

          const nextIndex = Math.max(0, Math.min(index, this.slides.length - 1));
          const previousIndex = this.current;
          const previousSlide = this.slides[previousIndex];
          const nextSlide = this.slides[nextIndex];
          const previousMotion = previousSlide?.querySelector('[data-solution-showcase-copy-motion]');
          const nextMotion = nextSlide?.querySelector('[data-solution-showcase-copy-motion]');
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const shouldAnimate = animate && previousIndex !== nextIndex && !reducedMotion;

          this.current = nextIndex;

          this.slides.forEach((slide, slideIndex) => {
            const isActive = slideIndex === nextIndex;

            slide.classList.toggle('is-active', isActive);
            slide.setAttribute('aria-hidden', String(!isActive));
            slide.toggleAttribute('inert', !isActive);
          });

          if (shouldAnimate) {
            const incomingOffset = direction < 0 ? -100 : 100;
            const outgoingOffset = incomingOffset * -1;
            const animationOptions = {
              duration: 520,
              easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
            };

            previousMotion?.getAnimations().forEach((animation) => animation.cancel());
            nextMotion?.getAnimations().forEach((animation) => animation.cancel());

            previousMotion?.animate(
              [
                { transform: 'translateX(0%)', opacity: 1 },
                { transform: `translateX(${outgoingOffset}%)`, opacity: 0 },
              ],
              animationOptions
            );
            nextMotion?.animate(
              [
                { transform: `translateX(${incomingOffset}%)`, opacity: 0 },
                { transform: 'translateX(0%)', opacity: 1 },
              ],
              animationOptions
            );
          }

          const accentColor = nextSlide?.dataset.accentColor;

          if (accentColor) {
            this.style.setProperty('--solution-showcase-active-color', accentColor);
          }

          if (this.progressThumb) {
            const slideCount = this.slides.length;
            const width = 100 / slideCount;
            const maxIndex = Math.max(slideCount - 1, 1);
            const travel = Math.max(100 - width, 0);

            this.progressThumb.style.width = `${width}%`;
            this.progressThumb.style.left = `${(nextIndex / maxIndex) * travel}%`;
            this.progressThumb.style.transform = 'none';
          }
        }

        handleKeydown(event) {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.go(-1);
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.go(1);
          }
        }

        handleTouchStart(event) {
          this.touchStartX = event.changedTouches[0]?.clientX ?? null;
        }

        handleTouchEnd(event) {
          if (this.touchStartX === null) return;

          const touchEndX = event.changedTouches[0]?.clientX ?? this.touchStartX;
          const distance = touchEndX - this.touchStartX;

          this.touchStartX = null;

          if (Math.abs(distance) < 44) return;

          this.go(distance > 0 ? -1 : 1);
        }

        handleThemeBlockSelect(event) {
          const selectedSlide = event.target?.closest?.('[data-solution-showcase-slide]');
          const index = this.slides.indexOf(selectedSlide);

          if (index >= 0) {
            const direction = index < this.current ? -1 : 1;
            this.select(index, true, direction);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
